import React, {useContext, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import './Login.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {AuthContext} from '../../contexts/authContext';
import { Button, TextInput } from '../_common';
import LOGO from '../../assets/wolte_logo.png';

const Login = () => {
  const { t } = useContext(I18nContext);
  const { logIn, pending, error } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const getReturnUrl = () => {
    const returnUrl = searchParams.get('returnUrl');
    if (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
      return returnUrl;
    }
    return '/';
  };

  const [formValues, setFormValues] = useState({email: '', password: ''});
  const [formErrors, setFormErrors] = useState({ok: false, email: false, password: false});

  const validateForm = () => {
    const newErrors = {...formErrors};
    newErrors.ok = true;
    if (!formValues.email) {
      newErrors.email = true;
      newErrors.ok = false;
    }
    if (!formValues.password) {
      newErrors.password = true;
      newErrors.ok = false;
    }
    setFormErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async () => {
    const validated = validateForm().ok;
    if (validated) {
      const logging = await logIn(formValues);
      if (logging.type !== 'Error') {
        navigate(getReturnUrl());
      }
    }
  };

  const handleSubmitOnEnterPress = e => {
    if (e.keyCode === 13) {
      handleSubmit();
    }
  };
  const changeValue = (name, value) => {
    const newValues = {...formValues};
    newValues[name] = value;
    setFormValues(newValues);
    const newErrors = {...formErrors};
    newErrors[name] = false;
    setFormErrors(newErrors);
  };

  return (
    <div className='Login'>
      <form className='form'>
        <div className='formHeader'>
          <div className='formHeaderLogo'>
            <img src={LOGO} className='logo' alt='logo' />
          </div>
          <div className='formHeaderTitle'>
            {t('log in', 'upper')}
          </div>
        </div>
        <div className='formInputs'>
          <TextInput
            name='email'
            label={t('e-mail')}
            placeholder={t('enter e-mail address')}
            onChange={changeValue}
            onKeyDown={handleSubmitOnEnterPress}
            required
            error={formErrors.email}
          />
          <TextInput
            name='password'
            label={t('password')}
            placeholder={t('enter password')}
            onChange={changeValue}
            onKeyDown={handleSubmitOnEnterPress}
            type='password'
            required
            error={formErrors.password}
          />
          {error && (
            <div className='errorMessage'>{t('wrong email or password')}.</div>
          )}
        </div>
        <div className='formButtons'>
          <Button label={t('log in')} action={handleSubmit} fullWidth pending={pending} />
        </div>
      </form>
    </div>
  );
};

export default Login;
